import { Spacer } from '@kizen/kds/Spacer';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Input from 'components/Kizen/Input';
import Select from 'components/Inputs/Select';
import BasicModal from 'components/Modals/presets/BasicModal';
import { useLoggableActivitiesQuery } from 'queries/models/activities-ts';
import { FORCE_ALL_RECORDS_SIZE } from 'services/helpers';

const NewLogActivityDialog = ({
  options,
  create = true,
  onConfirm,
  onHide,
  ...rest
}) => {
  const { t } = useTranslation();
  const [displayName, setDisplayName] = useState(
    options?.item?.displayName ?? ''
  );
  const [activityId, setActivityId] = useState(options?.item?.activityId);

  const handleConfirm = useCallback(() => {
    onConfirm(options, displayName, activityId);
  }, [onConfirm, options, displayName, activityId]);

  const handleCancel = useCallback(() => {
    onHide(create);
  }, [onHide, create]);

  const activityOptionsQuery = useLoggableActivitiesQuery({
    params: { page_size: FORCE_ALL_RECORDS_SIZE },
    queryOptions: {
      select: (data) => {
        return data.results.map((activity) => {
          return { value: activity.id, label: activity.name };
        });
      },
    },
  });

  const activityOptions = activityOptionsQuery.data ?? [];
  const selectedActivity = activityOptions.find(
    (opt) => opt.value === activityId
  );

  return (
    <BasicModal
      {...rest}
      heading={create ? t('Add Activity Button') : t('Edit Activity Button')}
      show
      onConfirm={handleConfirm}
      onHide={handleCancel}
      disabled={!activityId || !displayName.trim()}
      leftBtn={false}
    >
      <Input
        placeholder={t('Enter Display Name')}
        value={displayName}
        onChange={setDisplayName}
        label={t('Display Name')}
        inModal
      />
      <Spacer size={15} />
      <Select
        menuInline
        label={t('Activity')}
        placeholder={t('Choose Activity')}
        value={selectedActivity}
        options={activityOptionsQuery.data ?? []}
        onChange={(opt) => setActivityId(opt.value)}
      />
    </BasicModal>
  );
};

export default NewLogActivityDialog;
